import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the asset tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['monitoring/liveTrackingWidgetModule/get']
}

/**
 * Determines if the specified vehicle is expanded.
 *
 * @param vehicleId int
 */
export const isVehicleExpanded = (vehicleId) => {
  return store.getters['monitoring/liveTrackingWidgetModule/expandedVehicleIds'].hasOwnProperty(vehicleId)
}

/**
 * Expands the specific vehicle.
 *
 * @param vehicleId int
 */
export const expandVehicle = (vehicleId) => {
  store.commit('monitoring/liveTrackingWidgetModule/expandVehicle', vehicleId)
}

/**
 * En-expands the specific vehicle.
 *
 * @param vehicleId int
 */
export const unExpandVehicle = (vehicleId) => {
  store.commit('monitoring/liveTrackingWidgetModule/unExpandVehicle', vehicleId)
}

/**
 * Toggle's expand for the specific vehicle.
 *
 * @param vehicleId int
 */
export const toggleExpandVehicle = (vehicleId) => {
  if (isVehicleExpanded(vehicleId)) {
    unExpandVehicle(vehicleId)
  } else {
    expandVehicle(vehicleId)
  }
}

/**
 * Selects the specific vehicle, set to null to
 * clear selection.
 *
 * @param vehicleId int|null
 */
export const selectVehicle = (vehicleId) => {
  store.commit('monitoring/liveTrackingWidgetModule/selectVehicle', vehicleId)
}

/**
 * Returns the currently selected vehicle's id
 *
 * @return int|null
 */
export const selectedVehicle = () => {
  return store.getters['monitoring/liveTrackingWidgetModule/selectedVehicleId']
}

/**
 * Returns true if the specified vehicle is currently selected.
 *
 * @param vehicleId int|null
 */
export const isVehicleSelected = (vehicleId) => {
  return store.getters['monitoring/liveTrackingWidgetModule/selectedVehicleId'] === vehicleId
}

/**
 * Returns the currently selected asset type and id in the format:
 * { type: 'vehicle', id: 1 } or
 * { type: 'unit', id: 1 }
 *
 * @returns Object|null
 */
export const selectedAsset = () => {
  return store.getters['monitoring/liveTrackingWidgetModule/selectedAsset']
}

/**
 * Determines if the specified unit is expanded.
 *
 * @param unitId int
 */
export const isUnitExpanded = (unitId) => {
  return store.getters['monitoring/liveTrackingWidgetModule/expandedUnitIds'].hasOwnProperty(unitId)
}

/**
 * Expands the specific unit.
 *
 * @param unitId int
 */
export const expandUnit = (unitId) => {
  store.commit('monitoring/liveTrackingWidgetModule/expandUnit', unitId)
}

/**
 * En-expands the specific unit.
 *
 * @param unitId int
 */
export const unExpandUnit = (unitId) => {
  store.commit('monitoring/liveTrackingWidgetModule/unExpandUnit', unitId)
}

/**
 * Toggle's expand for the specific unit.
 *
 * @param unitId int
 */
export const toggleExpandUnit = (unitId) => {
  if (isUnitExpanded(unitId)) {
    unExpandUnit(unitId)
  } else {
    expandUnit(unitId)
  }
}

/**
 * Selects the specific unit, set to null to
 * clear selection.
 *
 * @param unitId int|null
 */
export const selectUnit = (unitId) => {
  store.commit('monitoring/liveTrackingWidgetModule/selectUnit', unitId)
}

/**
 * Returns the currently selected unit's id
 *
 * @return int|null
 */
export const selectedUnit = () => {
  return store.getters['monitoring/liveTrackingWidgetModule/selectedUnitId']
}

/**
 * Returns true if the specified unit is currently selected.
 *
 * @param unitId int|null
 */
export const isUnitSelected = (unitId) => {
  return store.getters['monitoring/liveTrackingWidgetModule/selectedUnitId'] === unitId
}

/**
 * Resets the live tracking state.
 */
export const purge = () => {
  store.commit('monitoring/liveTrackingWidgetModule/purge')
}



// WEBPACK FOOTER //
// ./src/store/monitoring/liveTrackingWidget.helpers.js